import { createFileRoute } from "@tanstack/react-router";

import ChallengeEntrySidebar from "@/components/ChallengeEntries/ChallengeEntrySidebar";

const Component = () => {
  return <ChallengeEntrySidebar />;
};

export const Route = createFileRoute(
  "/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid",
)({
  component: Component,
});
